import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  actionIconWrapper: {
    minWidth: '30px',
  },
  actionIcon: {
    width: '16px',
    height: '16px',
  },
}));
